export const eventTabsStyles = (theme) => {
  return {
    eventTabsText: {
      display: "block !important",
      [theme.breakpoints.down("sm")]: {
        display: "none !important",
      },
      [theme.breakpoints.up("sm")]: {
        display: "block !important",
      },
    },
    eventTabsIcons: {
      display: "none !important",
      [theme.breakpoints.down("sm")]: {
        display: "block !important",
      },
      [theme.breakpoints.up("sm")]: {
        display: "none !important",
      },
    },
  };
};
